import styled from 'styled-components'
import { Typography } from '@material-ui/core'
import { ArrowUpward } from '@material-ui/icons'
import ArrowDownward from '@material-ui/icons/ArrowDownward'
import { customColors } from '../config/theme'

const DataVariantionContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
`

interface DataVariationIndicatorProps {
  previousValue: number
  currentValue: number
  period: string
}

const getIndicatorColor = (isNegative: boolean) => {
  return isNegative ? customColors.fail : customColors.success
}

const getPercentageVariation = (previous: number, current: number) => {
  const correctPrevious = previous === 0 ? 1 : previous
  const diff = current - correctPrevious

  if (current === 0 && diff > 0) {
    return '-100%'
  }

  if (current === 0 && diff === 0) {
    return '0%'
  }
  return `${((diff / correctPrevious) * 100).toFixed(2)}%`
}
export default ({
  previousValue,
  currentValue,
  period,
}: DataVariationIndicatorProps) => {
  const variation = getPercentageVariation(previousValue, currentValue)
  const isNegative = variation.includes('-')

  return (
    <DataVariantionContainer>
      {isNegative ? (
        <ArrowDownward
          fontSize='small'
          style={{ color: getIndicatorColor(isNegative) }}
        />
      ) : (
        <ArrowUpward
          fontSize='small'
          style={{ color: getIndicatorColor(isNegative) }}
        />
      )}
      <Typography
        style={{ marginRight: 4, color: getIndicatorColor(isNegative) }}
      >
        {!isNegative && '+'}
        {getPercentageVariation(previousValue, currentValue)}
      </Typography>
      <Typography
        style={{ marginRight: 2 }}
        variant='caption'
        color='textSecondary'
      >
        {period}
      </Typography>
    </DataVariantionContainer>
  )
}
